module.exports = __webpack_public_path__ + "static/media/ic-radio-off.6e0780c7.svg";